import React from "react";
import Header from "../Landing/components/Header";
import Footer from "../Landing/components/Footer";
import privacyStyles from './PrivacyPolicy.module.css';
import styles from '../Landing/LandingPage.module.css';

const PrivacyPolicy = () => {
    return (
        <>
            <Header />
            <main>
                <section className={`${privacyStyles.hero} ${privacyStyles.heroPrivacy}`}>
                    <div className={styles.container}>
                        <div className={privacyStyles.heroContent}>
                            <h1>Privacy Policy</h1>
                            {/* <p>We're here to help you with any questions about posting jobs, finding professionals, or using our platform.</p> */}
                        </div>
                    </div>
                </section>
                
                <section className={privacyStyles.privacyWrapper}>
                    <div className={privacyStyles.privacyContainer}>

                        <p className={privacyStyles.lastUpdated}>
                            Last Updated: May 2026
                        </p>

                        <div className={privacyStyles.policySection}>
                            <h2>1. Introduction</h2>

                            <p>
                                Build Start ("we," "us," or "our") is committed to protecting your
                                privacy. This Privacy Policy explains how we collect, use, disclose,
                                and safeguard your information when you use our mobile application
                                and website (
                                <a
                                    href="https://buildstart.au"
                                    target="_blank"
                                    rel="noreferrer"
                                    className={privacyStyles.link}
                                >
                                    buildstart.au
                                </a>
                                ).
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>2. Information We Collect</h2>

                            <ul>
                                <li>
                                    <strong>Personal Information:</strong> Name, email address,
                                    phone number, and physical address.
                                </li>

                                <li>
                                    <strong>Business Information:</strong> Trade licences,
                                    insurance documentation, and business details.
                                </li>

                                <li>
                                    <strong>Visual Content:</strong> Photos of projects,
                                    blueprints, or site conditions.
                                </li>

                                <li>
                                    <strong>Location Data:</strong> GPS location data from
                                    your mobile device.
                                </li>

                                <li>
                                    <strong>Device Information:</strong> IP addresses,
                                    device IDs, and operating system details.
                                </li>
                            </ul>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>3. How We Use Your Information</h2>

                            <ul>
                                <li>Verify the identity and credentials of Verified Pros.</li>

                                <li>
                                    Connect homeowners with local service providers.
                                </li>

                                <li>
                                    Improve app functionality and user experience.
                                </li>

                                <li>
                                    Send project updates and notifications.
                                </li>
                            </ul>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>4. Sharing Your Information</h2>

                            <ul>
                                <li>
                                    <strong>With Other Users:</strong> Sharing project
                                    and business details.
                                </li>

                                <li>
                                    <strong>Third-Party Providers:</strong> Hosting,
                                    analytics, and licence verification.
                                </li>

                                <li>
                                    <strong>Legal Requirements:</strong> When required
                                    by law.
                                </li>
                            </ul>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>5. Access to User Communications</h2>

                            <p>
                                Build Start may access and review messages sent through
                                our internal messaging system for:
                            </p>

                            <ul>
                                <li>Safety and fraud investigations.</li>
                                <li>Dispute resolution.</li>
                                <li>Quality control purposes.</li>
                            </ul>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>6. Data Security</h2>

                            <p>
                                We take reasonable technical and organisational steps
                                to protect your information from misuse, loss,
                                or unauthorised access.
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>7. Sensitive Information</h2>

                            <p>
                                We may collect sensitive information only with your
                                consent and strictly for verification and safety purposes.
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>8. Direct Marketing</h2>

                            <p>
                                We may send promotional communications via email,
                                SMS, or MMS. You can unsubscribe at any time.
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>9. Facebook and Third-Party Platform Data</h2>

                            <p>
                                If you connect your account with Facebook or other
                                platforms, we may receive data from those services.
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>10. Your Rights and Choices</h2>

                            <ul>
                                <li>
                                    <strong>Access/Correction:</strong> Update your
                                    personal information.
                                </li>

                                <li>
                                    <strong>Deletion:</strong> Request deletion of your
                                    account and personal data.
                                </li>
                            </ul>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>11. Complaints and Resolution</h2>

                            <p>
                                Contact us at{" "}
                                <a
                                    href="mailto:help@buildstart.au"
                                    className={privacyStyles.link}
                                >
                                    help@buildstart.au
                                </a>
                                .
                            </p>

                            <p>
                                You may also contact the OAIC at{" "}
                                <a
                                    href="https://www.oaic.gov.au"
                                    target="_blank"
                                    rel="noreferrer"
                                    className={privacyStyles.link}
                                >
                                    www.oaic.gov.au
                                </a>
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>12. Policy Changes</h2>

                            <p>
                                We may update this policy periodically.
                            </p>
                        </div>

                        <div className={privacyStyles.policySection}>
                            <h2>13. Contact Us</h2>

                            <p>
                                Email:{" "}
                                <a
                                    href="mailto:help@buildstart.au"
                                    className={privacyStyles.link}
                                >
                                    help@buildstart.au
                                </a>
                            </p>
                        </div>

                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;